import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComments = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeMiterlimit: 10
	},
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20.425,17.85l-6.33,0l-5.39,4.553l0,-4.553l-5.16,0c-0.871,0 -1.578,-0.714 -1.578,-1.595l0,-12.44c0,-0.881 0.707,-1.595 1.578,-1.595l16.88,0c0.871,0 1.578,0.714 1.578,1.595l0,12.44c0,0.882 -0.707,1.595 -1.578,1.595Z",
			style: {
				fill: "none",
				fillRule: "nonzero",
				stroke: "currentColor",
				strokeWidth: "1.51px"
			}
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.265,12.311l9.788,0",
			style: {
				fill: "none",
				fillRule: "nonzero",
				stroke: "currentColor",
				strokeWidth: "1.51px",
				strokeLinecap: "butt"
			}
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.265,7.741l13.122,0",
			style: {
				fill: "none",
				fillRule: "nonzero",
				stroke: "currentColor",
				strokeWidth: "1.51px",
				strokeLinecap: "butt"
			}
		})
	] })
});
export default SvgComments;
